module.exports = __webpack_public_path__ + "static/media/wcgBoil.df918b20.jpg";